<template>
  <div style="background-color: #fff;">
    
  </div>

</template>


<script>



export default {
  data() {
    return {

    };
  },
  mounted(){
    let router = this.$route.params.router ;
    this.$route.params.router  = undefined ;
    if( router == 'explore' ){
      // /explore      
      this.$router.replace({
        path: "/explore" , // ⚠️注：这里不能用path路径，只能用name【请对照router.js中的路由规则中的name项】，否则取不到传过去的数据
        query : {
          params : this.$route.params._id ,
          personal : this.$route.params.personal ? this.$route.params.personal  : undefined  , 
        }
        // params: this.$route.params
      });

    } else if( router == 'personal'  ){
      this.$router.replace({
        path: "/personal" , // ⚠️注：这里不能用path路径，只能用name【请对照router.js中的路由规则中的name项】，否则取不到传过去的数据
        query : {
          user : this.$route.params.uid
        }
        // params: this.$route.params
      });
    } else if( router == 'taskCenter'  || router == 'myGroup' ){
      this.$router.replace({
        path: '/' + router , // ⚠️注：这里不能用path路径，只能用name【请对照router.js中的路由规则中的name项】，否则取不到传过去的数据
      });
    } else {
      this.$router.replace({
        name: router , // ⚠️注：这里不能用path路径，只能用name【请对照router.js中的路由规则中的name项】，否则取不到传过去的数据
        params: this.$route.params
      });
    }
  }
}
</script>


